import styles from "./ROISquare.module.scss";
import classNames from "classnames";

export const ROISquare = ({ size }: { size: number }) => (
  <div
    className={classNames(styles.square, { [styles.visible]: size > 0 })}
    style={{ width: size, height: size }}
  />
);
